import React, { CSSProperties } from 'react'
import type { Priority } from '../../types'

interface PriorityBadgeProps {
  priority: Priority
  showLabel?: boolean
  size?: 'sm' | 'md'
  style?: CSSProperties
}

const priorityConfig: Record<Priority, { color: string; label: string }> = {
  URGENT: { color: '#ef4444', label: 'Urgent' },
  HIGH: { color: '#f97316', label: 'High' },
  MEDIUM: { color: '#eab308', label: 'Medium' },
  LOW: { color: '#3b82f6', label: 'Low' },
  NO_PRIORITY: { color: '#94a3b8', label: 'No Priority' },
}

export const PriorityBadge: React.FC<PriorityBadgeProps> = ({
  priority,
  showLabel = true,
  size = 'md',
  style,
}) => {
  const config = priorityConfig[priority]
  const dotSize = size === 'sm' ? 7 : 9

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        fontSize: size === 'sm' ? '12px' : '13px',
        color: '#374151',
        ...style,
      }}
    >
      <span
        style={{
          width: dotSize,
          height: dotSize,
          borderRadius: '50%',
          background: config.color,
          flexShrink: 0,
          boxShadow: `0 0 0 2px ${config.color}33`,
        }}
      />
      {showLabel && config.label}
    </span>
  )
}
